import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface StatisticsChartsProps {
  successRates: {
    google: number;
    bing: number;
    total: number;
  } | undefined;
  dailyVolume: Array<{
    date: string;
    success: number;
    partial: number;
    failed: number;
  }> | undefined;
}

export const StatisticsCharts = ({ successRates, dailyVolume }: StatisticsChartsProps) => {
  const successRateData = successRates ? [
    { name: 'Google', rate: successRates.google },
    { name: 'Bing', rate: successRates.bing }
  ] : [];

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <Card>
        <CardHeader>
          <CardTitle>Success Rate by Engine</CardTitle>
        </CardHeader>
        <CardContent>
          {successRates ? (
            <>
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={successRateData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis domain={[0, 100]} />
                  <Tooltip />
                  <Bar dataKey="rate" fill="#10b981" />
                </BarChart>
              </ResponsiveContainer>
              <div className="mt-4 text-sm text-muted-foreground text-center">
                Based on {successRates.total} submissions in last 7 days
              </div>
            </>
          ) : (
            <div className="h-[200px] flex items-center justify-center text-muted-foreground">
              No data available
            </div>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Daily Indexing Volume</CardTitle>
        </CardHeader>
        <CardContent>
          {dailyVolume && dailyVolume.length > 0 ? (
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={dailyVolume}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="success" stackId="a" fill="#10b981" name="Success" />
                <Bar dataKey="partial" stackId="a" fill="#f59e0b" name="Partial" />
                <Bar dataKey="failed" stackId="a" fill="#ef4444" name="Failed" />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="h-[200px] flex items-center justify-center text-muted-foreground">
              No data available
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
